module.exports = __webpack_public_path__ + "i18n/de.b19cfb9091b029fc7d6ff5f878664ff6.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1000
// module chunks = 60